"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _variables = _interopRequireDefault(require("../utils/variables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = function styles(theme) {
  return {
    root: {
      marginLeft: -10,
      padding: 6,
      color: _variables["default"].primaryTheme,
      "&$checked": {
        color: _variables["default"].primaryTheme
      }
    },
    checked: {},
    smallSize: {
      transform: "scale(0.8)"
    },
    smallLabel: {
      fontSize: "12px"
    },
    grayCheckBox: {
      color: _variables["default"].grey4
    }
  };
};

var _default = styles;
exports["default"] = _default;